/*
 *******************************************************************************
 * 
 *  Filename:   ./constants/actionTypeSystemListGroups.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   System List Groups Action Type constant definitions.
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *  
 *  Created:    Saturday, September 15, 2018 - 9:37 PM (CST)
 *  
 *  Notes:
 *  
 *  
 *  Revisions:
 *      09/15/2018  NJN     File Created
 *      
 *  Copyright (c) 2018 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

export const SYSTEMLISTGROUP_LIST_CONTAINER_LOADED = 'SYSTEMLISTGROUP_LIST_CONTAINER_LOADED';
export const SYSTEMLISTGROUP_LIST_CONTAINER_UNLOADED = 'SYSTEMLISTGROUP_LIST_CONTAINER_UNLOADED';
export const SYSTEMLISTGROUP_LIST_TABLE_LOADED = 'SYSTEMLISTGROUP_LIST_TABLE_LOADED';
export const SYSTEMLISTGROUP_LIST_TABLE_UNLOADED = 'SYSTEMLISTGROUP_LIST_TABLE_UNLOADED';
export const SYSTEMLISTGROUP_LIST_CHANGE_COMPANY = 'SYSTEMLISTGROUP_LIST_CHANGE_COMPANY';
export const SYSTEMLISTGROUP_SELECT_ROW = 'SYSTEMLISTGROUP_SELECT_ROW';
export const SYSTEMLISTGROUP_ADD = 'SYSTEMLISTGROUP_ADD';
export const SYSTEMLISTGROUP_EDIT = 'SYSTEMLISTGROUP_EDIT';
export const SYSTEMLISTGROUP_DELETE = 'SYSTEMLISTGROUP_DELETE';
export const SYSTEMLISTGROUP_DELETE_DISABLE = 'SYSTEMLISTGROUP_DELETE_DISABLE';
export const SYSTEMLISTGROUP_OPEN_WARNING = 'SYSTEMLISTGROUP_OPEN_WARNING';
export const SYSTEMLISTGROUP_CLOSE_WARNING = 'SYSTEMLISTGROUP_CLOSE_WARNING';

export const SYSTEMLISTGROUP_EDIT_CONTAINER_LOADED = 'SYSTEMLISTGROUP_EDIT_CONTAINER_LOADED';
export const SYSTEMLISTGROUP_EDIT_CONTAINER_UNLOADED = 'SYSTEMLISTGROUP_EDIT_CONTAINER_UNLOADED';
export const SYSTEMLISTGROUP_EDIT_FORM_LOADED = 'SYSTEMLISTGROUP_EDIT_FORM_LOADED';
export const SYSTEMLISTGROUP_EDIT_FORM_UNLOADED = 'SYSTEMLISTGROUP_EDIT_FORM_UNLOADED';
export const SYSTEMLISTGROUP_EDIT_DATA_LOAD = 'SYSTEMLISTGROUP_EDIT_DATA_LOAD';
export const SYSTEMLISTGROUP_EDIT_CONTAINER_SUBMIT = 'SYSTEMLISTGROUP_EDIT_CONTAINER_SUBMIT';
export const SYSTEMLISTGROUP_EDIT_CONTAINER_CANCEL = 'SYSTEMLISTGROUP_EDIT_CONTAINER_CANCEL';


// WEBPACK FOOTER //
// ./src/constants/actionTypeSystemListGroups.js